<template>
  <div class="activehelp" v-if="ti != 0">
    <div class="page1" v-if="qi == 0">
      <div
        class="list"
        v-for="(q, i) in questions[ti - 1]"
        :key="'q' + i"
        @click="showQ(i)"
      >
        {{ q.q }}
      </div>
    </div>
    <div v-else>
      <div class="question">{{ questions[ti - 1][qi - 1].q }}</div>
      <div
        class="answer"
        v-if="typeof questions[ti - 1][qi - 1].a == 'string'"
        v-html="questions[ti - 1][qi - 1].a"
      ></div>
      <div v-else>
        <div
          class="troublelist"
          v-for="(t, i) in questions[ti - 1][qi - 1].a"
          :key="'trouble' + i"
          @click="toTrouble(i)"
        >
          {{ t.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ti: 0,
      qi: 0,
      lang: this.$route.params.lang
    };
  },
  computed: {
    titles() {
      return this.$t("helpCenter.title");
    },
    questions() {
      return this.$t("helpCenter.questions");
    }
  },
  mounted() {
    this.$i18n.locale = this.lang;
    this.ti = parseInt(this.$route.params.ti || 0);
    this.qi = parseInt(this.$route.params.qi || 0);
    document.title = this.titles[this.ti - 1];
  },
  watch: {
    $route: function(to, from) {
      window.location.reload();
    }
  },
  methods: {
    showQ(i) {
      this.$router.push(`/bs/${this.lang}/help/` + this.ti + "/" + (i + 1));
    },
    toTrouble(i) {
      this.$router.push(`/bs/${this.lang}/trouble/` + i);
    }
  }
};
</script>

<style lang="less" scoped>
.activehelp {
  min-height: 100%;
  width: 100%;
  box-sizing: border-box;
  background: #111117;
  padding: 40px 32px;
  .list {
    color: #f2f2f7;
    font-size: 14px;
    margin-bottom: 32px;
  }
  .question {
    color: #f2f2f7;
    margin-bottom: 20px;
    font-weight: 500;
    width: 100%;
  }
  .answer {
    width: 100%;
    font-size: 14px;
    line-height: 21px;
    color: #c7cad1;
  }
  .troublelist {
    font-size: 14px;
    color: #fff;
    margin: 20px 0;
    position: relative;
    padding-right: 20px;
  }
  .troublelist::before {
    content: "";
    width: 5px;
    height: 5px;
    border-top: 1px solid #fff;
    border-right: 1px solid #fff;
    position: absolute;
    margin: auto;
    top: 0;
    bottom: 0;
    right: 0;
    transform: rotate(45deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/help_multilingual/index.vue